import { useQuery } from "@tanstack/react-query";
import { ActorRef } from "@/services/bedrock/dtos/DesignPackage";
import { designKeys } from "@/services/bedrock/queryKeys";
import { useSocialCoachSession } from "@/utils/useSocialCoachSession";

const NO_VIEWERS: ActorRef[] = [];

/** Cache-only: the channel hook writes presence messages here. */
export function usePresence(packageId: number | null) {
  const { userId } = useSocialCoachSession();
  const { data } = useQuery({
    queryKey: designKeys.presence(packageId ?? 0),
    queryFn: () => NO_VIEWERS,
    staleTime: Infinity,
    gcTime: 0,
    enabled: packageId != null,
  });
  const viewers = (data ?? NO_VIEWERS).filter(viewer => Number(viewer.userId) !== Number(userId));
  return { viewers };
}
